var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Vue, Component, Mixins } from 'vue-property-decorator';
import * as addDays from 'date-fns/add_days';
import * as format from 'date-fns/format';
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);
import { lazyInject } from '@/dependency-injection';
import { TYPES } from '@/dependency-injection/types';
import { ReferenceDataService } from '@/services/reference-data-service';
import { ProfileService } from '@/services/profile-service';
import { MaterialGroupService } from '@/services/material-management/material-group-service';
import { UserService } from '@/services/user-management/user-service';
import SnackbarMixin from '@/mixins/snackbar-mixin';
var ReportFilters = /** @class */ (function (_super) {
    __extends(ReportFilters, _super);
    function ReportFilters() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.submitLoading = false;
        _this.item = {
            voyageLoadListVm: {},
            filterVm: [],
        };
        _this.validationRules = {};
        _this.options = {
            loadListReport: {
                from: [],
                to: [],
                views: [],
                markets: [],
            },
            opportunityReport: {
                range: [],
                types: [],
                carriers: [],
                markets: [],
                platts: [],
            },
            userTypes: [],
            userSubTypes: [],
            roles: [],
            locos: [],
            rsls: [],
            carriers: [],
            suppliers: [],
            sites: [],
            materialGroups: [],
            _carrierGroups: [],
            _carriers: [],
            _dispatchDesks: [],
        };
        return _this;
    }
    ReportFilters.prototype.validate = function (scope) {
        var _this = this;
        this.$validator.validateAll(scope).then(function (result) {
            if (result) {
                _this.save();
            }
        });
    };
    ReportFilters.prototype.created = function () {
        // initialize
        this.validationRules = this.userService.getValidationRules();
        this.item = this.profileService.getDefaultReportFiltersVm();
    };
    ReportFilters.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, 5, 6]);
                        this.loading = true;
                        return [4 /*yield*/, this.loadInitialReferenceData()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.lazyLoadReferenceData()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.getData()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        error_1 = _a.sent();
                        console.error(error_1);
                        this.showSnackbar({
                            text: 'Unable to get all data for report filters',
                            color: 'error',
                        });
                        return [3 /*break*/, 6];
                    case 5:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ReportFilters.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.submitLoading = true;
                        data = __assign({}, this.item);
                        if (this.profileService.canViewOpportunityReportFilters &&
                            data.filterVm.length === 0) {
                            // tslint:disable-next-line:max-line-length
                            this.$validator.errors.add({
                                field: 'statuses',
                                scope: 'report_filters',
                                msg: 'You must have at least one status selected',
                            });
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.profileService.saveReportFiltersVm(data)];
                    case 1:
                        response = _a.sent();
                        this.showSnackbar({
                            text: 'Report filters changes saved',
                            color: 'success',
                        });
                        return [3 /*break*/, 4];
                    case 2:
                        error_2 = _a.sent();
                        console.error(error_2);
                        this.showSnackbar({
                            text: 'Unable to save report filters',
                            color: 'error',
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        this.submitLoading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ReportFilters.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.profileService.getReportFiltersVm()];
                    case 1:
                        _a.item = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ReportFilters.prototype.loadInitialReferenceData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var dispatchDesks, allCarrier;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.referenceDataService.get('/carrier/getdispatchdesks')];
                    case 1:
                        dispatchDesks = (_a.sent());
                        allCarrier = [{ key: 'ALL', value: '' }];
                        this.options.opportunityReport.carriers = allCarrier.concat(dispatchDesks.map(function (item) { return ({ key: item.id, value: item.name }); }));
                        return [2 /*return*/];
                }
            });
        });
    };
    ReportFilters.prototype.lazyLoadReferenceData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, _d, _e, markets, referenceDataResponse, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        // get sites
                        _a = this.options;
                        return [4 /*yield*/, this.referenceDataService.get('/site/getsites')];
                    case 1:
                        // get sites
                        _a.sites = _g.sent();
                        // get groups
                        _b = this.options;
                        return [4 /*yield*/, this.materialGroupService.getAllRef(true)];
                    case 2:
                        // get groups
                        _b.materialGroups = (_g.sent()).data;
                        if (!this.profileService.canViewVoyageLoadListReportFilters) return [3 /*break*/, 7];
                        // tslint:disable-next-line:max-line-length
                        _c = this.options.loadListReport;
                        return [4 /*yield*/, this.referenceDataService.get('/loadlistreport/getfromdates')];
                    case 3:
                        // tslint:disable-next-line:max-line-length
                        _c.from = _g.sent();
                        _d = this.options.loadListReport;
                        return [4 /*yield*/, this.referenceDataService.get('/loadlistreport/gettodates')];
                    case 4:
                        _d.to = _g.sent();
                        _e = this.options.loadListReport;
                        return [4 /*yield*/, this.referenceDataService.get('/loadlistreport/getviews')];
                    case 5:
                        _e.views = _g.sent();
                        return [4 /*yield*/, this.referenceDataService.get('/site/getmarkets')];
                    case 6:
                        markets = _g.sent();
                        this.options.loadListReport.markets = markets;
                        this.options.opportunityReport.markets = markets;
                        _g.label = 7;
                    case 7:
                        if (!this.profileService.canViewOpportunityReportFilters) return [3 /*break*/, 10];
                        return [4 /*yield*/, this.referenceDataService.getModulesByRequest({ modules: [
                                    'OPPORTUNITY_STATUS', 'PLATTS',
                                ], includeDeleted: false })];
                    case 8:
                        referenceDataResponse = _g.sent();
                        // opportunity statuses
                        this.options.opportunityReport.types = referenceDataResponse.success
                            ? referenceDataResponse.data.filter(function (item) { return item.module === 'OPPORTUNITY_STATUS'; })
                            : [];
                        this.options.opportunityReport.platts = referenceDataResponse.success
                            ? referenceDataResponse.data.filter(function (item) { return item.module === 'PLATTS'; })
                            : [];
                        this.options.opportunityReport.platts.unshift({ shortDescription: 'ALL', code: '' });
                        // tslint:disable-next-line:max-line-length
                        _f = this.options.opportunityReport;
                        return [4 /*yield*/, this.referenceDataService.get('/opportunityreport/getdaterange')];
                    case 9:
                        // tslint:disable-next-line:max-line-length
                        _f.range = _g.sent();
                        _g.label = 10;
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ReportFilters.prototype, "voyageListFromDisplayText", {
        get: function () {
            return this.getFormattedDateForHintText(this.item.voyageLoadListVm.fromDate);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ReportFilters.prototype, "voyageListToDisplayText", {
        get: function () {
            return this.getFormattedDateForHintText(this.item.voyageLoadListVm.toDate);
        },
        enumerable: false,
        configurable: true
    });
    ReportFilters.prototype.getFormattedDateForHintText = function (daysDifference, offset) {
        if (offset === void 0) { offset = 0; }
        return "e.g. " + format(addDays(new Date(), +daysDifference + offset), 'ddd MMMM Do, YYYY');
    };
    ReportFilters.prototype.findMatchingFilter = function (module, component) {
        return this.item.filterVm.find(function (o) { return o.component === component && o.module === module; });
    };
    ReportFilters.prototype.getFilterItem = function (module, component) {
        var matchingItem = this.findMatchingFilter(module, component);
        return matchingItem && matchingItem.value
            ? matchingItem.value
            : '';
    };
    ReportFilters.prototype.updateFilterItem = function (module, component, value) {
        var matchingItem = this.findMatchingFilter(module, component);
        if (matchingItem) {
            matchingItem.value = value;
        }
    };
    ReportFilters.prototype.getFilterItemArray = function (module, component) {
        var matchingItem = this.findMatchingFilter(module, component);
        return matchingItem && matchingItem.value
            ? matchingItem.value.split('|')
            : [];
    };
    ReportFilters.prototype.updateFilterItemArray = function (module, component, value) {
        var matchingItem = this.findMatchingFilter(module, component);
        if (matchingItem) {
            matchingItem.value = value.join('|');
        }
    };
    var _a, _b, _c, _d;
    __decorate([
        lazyInject(TYPES.ReferenceDataService),
        __metadata("design:type", typeof (_a = typeof ReferenceDataService !== "undefined" && ReferenceDataService) === "function" ? _a : Object)
    ], ReportFilters.prototype, "referenceDataService", void 0);
    __decorate([
        lazyInject(TYPES.ProfileService),
        __metadata("design:type", typeof (_b = typeof ProfileService !== "undefined" && ProfileService) === "function" ? _b : Object)
    ], ReportFilters.prototype, "profileService", void 0);
    __decorate([
        lazyInject(TYPES.UserService),
        __metadata("design:type", typeof (_c = typeof UserService !== "undefined" && UserService) === "function" ? _c : Object)
    ], ReportFilters.prototype, "userService", void 0);
    __decorate([
        lazyInject(TYPES.MaterialGroupService),
        __metadata("design:type", typeof (_d = typeof MaterialGroupService !== "undefined" && MaterialGroupService) === "function" ? _d : Object)
    ], ReportFilters.prototype, "materialGroupService", void 0);
    ReportFilters = __decorate([
        Component({
            $_veeValidate: { validator: 'new' },
        })
    ], ReportFilters);
    return ReportFilters;
}(Mixins(SnackbarMixin)));
export default ReportFilters;
